import { parseFontStr, fontObjectToString } from './fontParser';
const getMobileFontSize = (desktopFontSize) => {
    const MOBILE_DEFAULT_MIN_FONT_SIZE = 12;
    const MOBILE_MAX_FONT_SIZE = 50;
    const SCALING_FACTOR = 3;
    const MIN_SCALED_FONT_SIZE = 14;
    const MEDIUM_SCALED_FONT_SIZE = 26;
    const MAX_SCALED_FONT_SIZE = 100;
    let mobileFontSize;
    const intDesktopFontSize = Math.round(desktopFontSize);
    if (intDesktopFontSize < MOBILE_DEFAULT_MIN_FONT_SIZE) {
        mobileFontSize = MOBILE_DEFAULT_MIN_FONT_SIZE;
    }
    else if (intDesktopFontSize <= MIN_SCALED_FONT_SIZE) {
        mobileFontSize = intDesktopFontSize + 1;
    }
    else if (intDesktopFontSize <= MEDIUM_SCALED_FONT_SIZE - 1) {
        mobileFontSize = intDesktopFontSize;
    }
    else if (intDesktopFontSize <= MAX_SCALED_FONT_SIZE) {
        mobileFontSize = Math.floor((intDesktopFontSize - MEDIUM_SCALED_FONT_SIZE) / SCALING_FACTOR +
            MEDIUM_SCALED_FONT_SIZE);
    }
    else {
        mobileFontSize = MOBILE_MAX_FONT_SIZE;
    }
    return mobileFontSize;
};
const convertFontSizeToMobile = (fontSize, scale) => {
    const mobileFontSize = getMobileFontSize(fontSize);
    return scale * mobileFontSize;
};
export const getMobileScaledFont = (fontString, scale, minimumFontSize = 0, fontSizeOverride = null) => {
    const parsedFont = parseFontStr(fontString);
    const scaledSize = convertFontSizeToMobile(parsedFont.size, scale);
    const fontSize = fontSizeOverride ||
        (minimumFontSize ? Math.max(minimumFontSize, scaledSize) : scaledSize);
    const scaledFont = { ...parsedFont, size: fontSize };
    return fontObjectToString(scaledFont);
};
export const getScaledFont = (compInfo, fontVarName, mobileFontSizeOverride, minimumFontSize = 0) => {
    const { compLayout, compProps, styleProperties, siteFonts, isMobileView, siteFontsSpxResolved, } = compInfo;
    const fontParam = styleProperties[fontVarName];
    const fontValue = siteFontsSpxResolved?.[fontParam] ?? siteFonts[fontParam] ?? fontParam;
    const scale = compProps?.fontScale ?? compLayout.scale ?? 1;
    return isMobileView && fontValue
        ? getMobileScaledFont(fontValue, scale, minimumFontSize, mobileFontSizeOverride)
        : fontValue;
};
//# sourceMappingURL=getScaledFont.js.map